<template>
  <section class="selection-mode">
    <div class="selection-mode__content">
      <h1 class="selection-mode__title">
        {{ $t('app.assessment_mode.selection.title') }}
      </h1>

      <assessment-mode-option-card
        v-for="option in options"
        :key="option.mode"
        :description="option.description"
        :icon="option.icon"
        :mode="option.mode"
        :title="option.title"
        @select="selectMode"
      />
    </div>
  </section>
</template>

<script>
import { mdiClipboardCheckOutline, mdiFileDocumentOutline, mdiMicrophoneOutline } from '@mdi/js'
import AssessmentModeOptionCard from '@/components/AssessmentMode/AssessmentModeOptionCard'

const OPTION_DEFINITIONS = [
  {
    mode: 'guided',
    titleToken: 'app.assessment_mode.selection.guided.title',
    descriptionToken: 'app.assessment_mode.selection.guided.description',
    icon: mdiClipboardCheckOutline,
  },
  {
    mode: 'voice',
    titleToken: 'app.assessment_mode.selection.voice.title',
    descriptionToken: 'app.assessment_mode.selection.voice.description',
    icon: mdiMicrophoneOutline,
  },
  {
    mode: 'text',
    titleToken: 'app.assessment_mode.selection.text.title',
    descriptionToken: 'app.assessment_mode.selection.text.description',
    icon: mdiFileDocumentOutline,
  },
]

export default {
  name: 'SelectionMode',
  components: {
    AssessmentModeOptionCard,
  },
  computed: {
    options() {
      return OPTION_DEFINITIONS.map(({ titleToken, descriptionToken, ...option }) => ({
        ...option,
        title: this.$t(titleToken),
        description: this.$t(descriptionToken),
      }))
    },
  },
  methods: {
    goTo(routeName) {
      this.$router.push({ name: routeName })
    },
    selectMode(mode) {
      this.goTo(`AssessmentMode${mode.charAt(0).toUpperCase()}${mode.slice(1)}`)
    },
  },
}
</script>

<style scoped>
.selection-mode {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  min-height: calc(100vh - 220px);
  padding: 36px 20px 64px;
  box-sizing: border-box;
}

.selection-mode__content {
  width: min(100%, 800px);
  margin: 0 auto;
  padding: 32px 12px 24px;
}

.selection-mode__title {
  margin: 0 0 28px;
  color: #173149;
  font-size: 2rem;
  font-weight: 700;
  line-height: 1.2;
  text-align: center;
}

@media screen and (max-width: 600px) {
  .selection-mode {
    padding: 24px 16px;
  }

  .selection-mode__title {
    font-size: 1.65rem;
    margin-bottom: 22px;
  }
}
</style>
